<template>
<div class="chapter">
<div class="inner_page">
<p class="imagef"><a id="page_ix"></a><img alt="Images" src="images/f0ix-01.jpg"/></p>
<h2 class="h2f">contents</h2>
<table border="0" cellpadding="1" cellspacing="0" width="100%">
<colgroup><col width="25%"/>
<col width="75%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="tabtxtr"><a href="#/xhtml/prelude"><span class="small"><strong>PRELUDE</strong></span></a></p></td>
<td valign="top"><p class="tabtxtl"><a href="#/xhtml/prelude">Edition 2.0</a></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><a href="#/xhtml/introduction"><span class="small"><strong>INTRODUCTION</strong></span></a></p></td>
<td valign="top"><p class="tabtxtl"><a href="#/xhtml/introduction">This Book Is Required Reading</a></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><a href="#/xhtml/ch1"><span class="small"><strong>ONE</strong></span></a></p></td>
<td valign="top"><p class="tabtxtl"><a href="#/xhtml/ch1">Welcome to Your Field Guide</a></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><a href="#/xhtml/ch2"><span class="small"><strong>TWO</strong></span></a></p></td>
<td valign="top"><p class="tabtxtl"><a href="#/xhtml/ch2">Assess Yourself</a></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch3" title="Link target outside of Sample"><span class="small"><strong>THREE</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch3" title="Link target outside of Sample">Smashing Stereotypes</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch4" title="Link target outside of Sample"><span class="small"><strong>FOUR</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch4" title="Link target outside of Sample">Why We Hate to Network</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch5" title="Link target outside of Sample"><span class="small"><strong>FIVE</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch5" title="Link target outside of Sample">Good-bye, Golden Rule</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch6" title="Link target outside of Sample"><span class="small"><strong>SIX</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch6" title="Link target outside of Sample">Sparkling New Strategies</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch7" title="Link target outside of Sample"><span class="small"><strong>SEVEN</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch7" title="Link target outside of Sample">Networking Event Survival Kit</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch8" title="Link target outside of Sample"><span class="small"><strong>EIGHT</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch8" title="Link target outside of Sample">Without a Net: Beyond Networking Events</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch9" title="Link target outside of Sample"><span class="small"><strong>NINE</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch9" title="Link target outside of Sample">The Job Search</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch10" title="Link target outside of Sample"><span class="small"><strong>TEN</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch10" title="Link target outside of Sample">Business Travel</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch11" title="Link target outside of Sample"><span class="small"><strong>ELEVEN</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch11" title="Link target outside of Sample">Structuring Events That Work for All</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch12" title="Link target outside of Sample"><span class="small"><strong>TWELVE</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch12" title="Link target outside of Sample">Follow Up or Go Home</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/ch13" title="Link target outside of Sample"><span class="small"><strong>THIRTEEN</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/ch13" title="Link target outside of Sample">Creating a Community</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tabtxtr"><span href="#/xhtml/conclusion" title="Link target outside of Sample"><span class="small"><strong>CONCLUSION</strong></span></span></p></td>
<td valign="top"><p class="tabtxtl"><span href="#/xhtml/conclusion" title="Link target outside of Sample">See Ya Later, Alligator</span></p></td>
</tr>
</tbody></table>
<p class="tocb"><a id="page_x"></a><span href="#/xhtml/appendix" title="Link target outside of Sample">Appendix</span></p>
<p class="tocb"><span href="#/xhtml/reads" title="Link target outside of Sample">Relevant Reads</span></p>
<p class="tocb"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocb"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="tocb"><span href="#/xhtml/back01" title="Link target outside of Sample">About Only Connect Consulting</span></p>
<p class="tocba"><span href="#/xhtml/author01" title="Link target outside of Sample">Your Fearless Author</span></p>
<p class="tocba"><span href="#/xhtml/back02" title="Link target outside of Sample">The <em>Get to It!</em> Toolkit</span></p>
<p class="tocb1"><span href="#/xhtml/back02#sec1" title="Link target outside of Sample">Online Self-Assessment</span></p>
<p class="tocb1"><span href="#/xhtml/back03#sec2" title="Link target outside of Sample">Official Micro-Course</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?29e6068b